// Hier werden sämtichen Konstanten definiert und mit sprechendem Namen versehen
// Diese können dann nach import in allen Module verwendet werden

// Constants for Authentication
export const NOT_AUTHORIZED = 0;
export const AUTHORIZED = 1;

// am_studiotechnik_ID
export const ID_INTERAKTIVE_MEDIEN = '1';
export const ID_INTERNET = '2';
export const ID_COMPUTERANIMATION = '3';
export const ID_FILM = '4';
export const ID_VISUAL_EFFECTS = '5';
export const ID_FERNSEHEN = '6';
export const ID_EVENT_MEDIA = '7';
export const ID_TON = '8';

// rechte_ring
export const GESPERRT = 0;
export const HDM_INTERN = 1;
export const OEFFENTLICH = 2;

// projekt_medienart_id
export const MEDIENART_SOFTWAREENTWICKLUNG = '12';
export const MEDIENART_FILM_ANIMATION_VFX = '16';
export const MEDIENART_GAMES = '18';
export const MEDIENART_MOBILE = '19';
